const renderPdf = {
  header: 'القطاعات الأكثر شعبية',
};

export default renderPdf;
